import { render } from "./Character_voted.vue?vue&type=template&id=6ef0d490"
import script from "./Character_voted.vue?vue&type=script&lang=js"
export * from "./Character_voted.vue?vue&type=script&lang=js"

import exportComponent from "/Users/news/Desktop/source/topic_freddy/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])